import React from "react";
import styled from "styled-components";
import { Button } from "@shared/ui/Button";
import { FormProvider, useForm } from "react-hook-form";
import { useTranslation } from "next-i18next";
import { IApplicationFormStep2 } from "@entities/Product/Application/types";
import { zodResolver } from "@hookform/resolvers/zod";
import { applicationValidationStep2Schema } from "@entities/Product/Application/utils";
import { useUnit } from "effector-react";
import {
  $applicationFormStep2,
  submitApplicationStep2,
} from "@entities/Product/Application/model";
import { Step2Fields } from "@entities/Product/Application/ui/Step2Fields";

interface IProps {
  cities: { value: string; label: string }[];
}

export function ApplicationStep2({ cities }: IProps) {
  const { t } = useTranslation();
  const [step2Data, submitStep] = useUnit([
    $applicationFormStep2,
    submitApplicationStep2,
  ]);

  const methods = useForm<IApplicationFormStep2>({
    mode: "onChange",
    shouldUnregister: false,
    resolver: zodResolver(applicationValidationStep2Schema(t)),
    defaultValues: step2Data,
  });

  const onSubmit = methods.handleSubmit((data) => {
    submitStep(data);
  });

  return (
    <StyledWrapper onSubmit={onSubmit}>
      <FormProvider {...methods}>
        <Step2Fields cities={cities} />
      </FormProvider>
      <StyledBottom>
        <div />
        <Button type="submit" disabled={!methods.formState.isValid}>
          {t(`Далее`)}
        </Button>
      </StyledBottom>
    </StyledWrapper>
  );
}

const StyledWrapper = styled.form`
  display: grid;
  grid-gap: 2.4rem;

  @media screen and (max-width: ${(props) => props.theme.sizes.tabletMin}) {
    grid-gap: 1.6rem;
  }
`;

const StyledBottom = styled.div`
  display: grid;
  margin-top: 1.6rem;
  grid-template-columns: 1.2fr 1.8fr;

  @media screen and (max-width: ${(props) => props.theme.sizes.tabletMin}) {
    grid-template-columns: 1fr;
  }
`;
